<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    科苑站<br>
站点介绍<br>
科苑站位于深圳市南山区高新科技园区，车站顺高新南十道布置，自西向东与科苑南路、高新南环路、科技南路垂直相交，车站出入口分别靠近各软件产业基地、科技生态园、留学生创业园等产业园区及写字楼。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:41	00:21	2号线	2分35秒	5分45秒<br>
莲塘	06:01	23:19	2号线	2分35秒	5分45秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:46	00:20	2号线	4分钟	5分钟<br>
莲塘	06:04	23:19	2号线	4分钟	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:46	01:10	2号线	4分钟	5分钟<br>
莲塘	06:04	00:19	2号线	4分钟	5分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
科苑南路(南)、中信·海阔天空雅居、深圳百度国际大厦、高新区联合总部大厦<br><br>
B出入口:<br>
高新南十道南侧、高新南环路南侧、深圳南山外国语学校科苑小学、深圳南山外国语学校高新中学、阳光带海滨城一期、阳光带海滨城二期、海怡东方、滨福庭园<br><br>
C出入口:<br>
高新南十道北侧、高新南环路北侧、威新软件园、深圳市留学生创业园、深圳湾科技生态园、深圳湾创新科技中心<br><br>
D出入口:<br>
科苑南路(北)、南京大学深圳产学研基地、中国地质大学产学研基地、华中科技大学产学研基地、武汉大学深圳产学研究大楼、虚拟大学园、中山大学深圳产学研基地、深圳综合细胞库<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 科苑地铁站<br>
B605、M209、M562、E19、M299、、M467、高峰专线92号、M554、旅游9号<br><br>
B出入口:<br>
公交站名： 科苑南路口<br>
72、325、B964、高峰专线120号<br><br>
C出入口:<br>
公交站名： 科苑南路口<br>
72、B605、M467、M209、高峰专线120号，<br><br>
D出入口:<br>
公交站名： 科苑地铁站<br>
B605、325、E19、M201、M299、M429、M467、325、高峰专线138号、高峰专线92号、M554、高峰专线150号、旅游9号<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>